import React, { useEffect, useState } from 'react';
import { Card, CardBody, Badge, Row, Col, Spinner, Alert, Input, FormGroup, Label } from 'reactstrap';
import { connect } from 'react-redux';
import { setBreadcrumbItems } from '../../store/actions';
import api from '../../utils/api';

const entityLabels = { journalist: 'صحفي', activist: 'ناشط', institution: 'مؤسسة' };
const actionLabels = { create: 'إنشاء', update: 'تعديل', delete: 'حذف' };
const statusColors = { pending: 'warning', approved: 'success', rejected: 'danger', partially_approved: 'info' };
const statusLabels = { pending: 'معلّق', approved: 'موافق', rejected: 'مرفوض', partially_approved: 'موافقة جزئية' };

const MyRequests = (props) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [statusFilter, setStatusFilter] = useState('');

  useEffect(() => {
    props.setBreadcrumbItems('طلباتي', [
      { title: 'الرئيسية', link: '/dashboard' },
      { title: 'طلباتي', link: '#' },
    ]);
  }, []);

  useEffect(() => { fetchRequests(); }, [page, statusFilter]);

  const fetchRequests = async () => {
    setLoading(true);
    try {
      const params = { page };
      if (statusFilter) params.status = statusFilter;
      const res = await api.get('/my-requests', { params });
      setItems(res.data.data || []);
      setLastPage(res.data.last_page || 1);
    } catch {
      setError('فشل في جلب الطلبات');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {error && <Alert color="danger">{error}</Alert>}

      <Card className="mb-3">
        <CardBody>
          <Row>
            <Col md={4}>
              <FormGroup className="mb-0">
                <Label className="fw-bold">الحالة</Label>
                <Input type="select" value={statusFilter} onChange={e => { setStatusFilter(e.target.value); setPage(1); }}>
                  <option value="">الكل</option>
                  <option value="pending">معلّق</option>
                  <option value="approved">موافق</option>
                  <option value="rejected">مرفوض</option>
                  <option value="partially_approved">موافقة جزئية</option>
                </Input>
              </FormGroup>
            </Col>
          </Row>
        </CardBody>
      </Card>

      {loading ? (
        <div className="text-center py-5"><Spinner color="primary" /><p className="mt-2">جار التحميل...</p></div>
      ) : items.length === 0 ? (
        <Alert color="info">لا يوجد طلبات</Alert>
      ) : (
        <>
          <Row>
            {items.map(item => (
              <Col md={6} lg={4} key={item.id} className="mb-3">
                <Card className="h-100">
                  <CardBody>
                    <div className="d-flex justify-content-between mb-2">
                      <Badge color={item.action === 'create' ? 'success' : item.action === 'update' ? 'info' : 'danger'}>
                        {actionLabels[item.action]}
                      </Badge>
                      <Badge color={statusColors[item.status]}>
                        {statusLabels[item.status]}
                      </Badge>
                    </div>
                    <h6 className="mb-2">
                      <Badge color="primary" className="me-2">{entityLabels[item.entity_type]}</Badge>
                      {item.new_data?.full_name || item.new_data?.title || item.original_data?.full_name || item.original_data?.title || '—'}
                    </h6>
                    <div className="text-muted small">
                      <i className="mdi mdi-clock-outline me-1"></i>
                      {(() => { const d = new Date(item.created_at); return `${d.getDate()}/${d.getMonth()+1}/${d.getFullYear()} ${d.getHours().toString().padStart(2,'0')}:${d.getMinutes().toString().padStart(2,'0')}`; })()}
                    </div>

                    {item.action === 'update' && item.changed_fields && (
                      <div className="mt-2 small text-muted">
                        <i className="mdi mdi-pencil me-1"></i>
                        {item.changed_fields.length} حقل معدّل
                      </div>
                    )}

                    {item.admin_note && (
                      <div className="mt-2 p-2 bg-light rounded small">
                        <strong>ملاحظة المراجع:</strong> {item.admin_note}
                      </div>
                    )}

                    {item.reviewer && (
                      <div className="mt-2 small text-muted">
                        <i className="mdi mdi-account-check me-1"></i>
                        المراجع: {item.reviewer.name}
                        {item.reviewed_at && (() => { const d = new Date(item.reviewed_at); return ` — ${d.getDate()}/${d.getMonth()+1}/${d.getFullYear()}`; })()}
                      </div>
                    )}

                    {/* عرض قرارات الحقول إذا كانت موافقة جزئية */}
                    {item.status === 'partially_approved' && item.field_decisions && (
                      <div className="mt-2 small">
                        <strong className="d-block mb-1">قرارات الحقول:</strong>
                        {Object.entries(item.field_decisions).map(([f, d]) => (
                          <div key={f}>
                            <Badge color={d === 'approved' ? 'success' : 'danger'} className="me-1" style={{fontSize:'0.7rem'}}>
                              {d === 'approved' ? '✓' : '✗'}
                            </Badge>
                            <span>{f}</span>
                          </div>
                        ))}
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>

          {lastPage > 1 && (
            <div className="d-flex justify-content-center mt-3 gap-2">
              <button className="btn btn-outline-primary" disabled={page === 1} onClick={() => setPage(page - 1)}>السابق</button>
              <span className="align-self-center">صفحة {page} من {lastPage}</span>
              <button className="btn btn-outline-primary" disabled={page === lastPage} onClick={() => setPage(page + 1)}>التالي</button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default connect(null, { setBreadcrumbItems })(MyRequests);
